
jQuery(document).ready(function($) {


  var $materials   = $('.materials', '.md-megamenu');
  var $equipment   = $('.equipment', '.md-megamenu');
  var $consumables = $('.consumables', '.md-megamenu');
  var $services    = $('.services', '.md-megamenu');
  var $overlay     = $('.md-overlay__cover');


// Overlays for Materials Button
  $materials.click(function() {
    $overlay.toggleClass('md-overlay__cover--show')
  });

  $materials.mouseleave(function() {
    $overlay.removeClass('md-overlay__cover--show')
  });

// Overlays for Equipment Button
  $equipment.click(function() {
    $overlay.toggleClass('md-overlay__cover--show')
  });

  $equipment.mouseleave(function() {
    $overlay.removeClass('md-overlay__cover--show')
  });

// Overlays for Consumables Button
  $consumables.click(function() {
    $overlay.toggleClass('md-overlay__cover--show')
  });

  $consumables.mouseleave(function() {
    $overlay.removeClass('md-overlay__cover--show')
  });

// Overlays for Services Button
  $services.click(function() {
    $overlay.toggleClass('md-overlay__cover--show')
  });

   $services.mouseleave(function() {
    $overlay.removeClass('md-overlay__cover--show')
  });


});



// WEBPACK FOOTER //
// ./lib/assets/js/vendor/megamenu/megamenu-options.js